import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  headerCell: {
    backgroundColor: theme.palette.blue.light,
    color: theme.palette.common.white,
    height: "60px",
    padding: theme.spacing(1),
    fontWeight: "bold",
    fontSize: 12,
  },
  headerCellWrapper: {
    display: "flex",
    alignItems: "center",
    textAlign: "center",
  },
  headerCellButtonWrapper: {
    display: "flex",
    marginLeft: 5,
    cursor: "pointer",
    "& svg": {
      fontSize: 20,
    },
  },
  cell: {
    fontSize: 11,
    color: "#293056",
    fontWeight: "bold",
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 15,
    paddingRight: 15,
  },
  tableRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#EEF6FB",
    },
  },
}));

export default useStyles;
